import {combineReducers, configureStore} from '@reduxjs/toolkit'
import {useDispatch} from "react-redux";
import userReducer from './reducers/UserSlice'
import transactionsReducer from './reducers/TransactionsSlice/TransactionsSlice'
import storage from 'redux-persist/lib/storage'
import hardSet from 'redux-persist/lib/stateReconciler/hardSet'
import {persistReducer } from 'redux-persist'
import createSagaMiddleware from 'redux-saga'; // Импорт Saga
import rootSaga from './sagas'; // Импорт корневой саги

const persistConfig = {
    key: 'root_redux',
    storage,
    stateReconciler: hardSet,
}

const rootReducer = combineReducers({
    userReducer,
    transactionsReducer,
})

const persistedReducer = persistReducer<ReturnType<typeof rootReducer>>(persistConfig, rootReducer)

const sagaMiddleware = createSagaMiddleware();

export const setupStore = () => {
    const store = configureStore({
        reducer: persistedReducer,
        middleware: (getDefaultMiddleware) => 
            getDefaultMiddleware({
                serializableCheck: false, // Важно для redux-persist
            }).concat(sagaMiddleware), // Добавляем Saga middleware
    });

    // Запускаем корневую сагу
    sagaMiddleware.run(rootSaga);

    return store;
};


// Infer the `RootState` and `AppDispatch` types from the store itself
// export type RootState = ReturnType<typeof store.getState>
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
// export type AppDispatch = typeof store.dispatch

export type RootState = ReturnType<typeof rootReducer>
export type AppStore = ReturnType<typeof setupStore>
export type AppDispatch = AppStore['dispatch']
export const useAppDispatch: () => AppDispatch = useDispatch
